var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResourceActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2263_16017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.99984H18.3327M1.66602 5.83317H5.83268M14.166 5.83317H18.3327M1.66602 14.1665H5.83268M14.166 14.1665H18.3327M5.83268 18.3332V1.6665M14.166 18.3332V1.6665M5.66602 18.3332H14.3327C15.7328 18.3332 16.4329 18.3332 16.9677 18.0607C17.4381 17.821 17.8205 17.4386 18.0602 16.9681C18.3327 16.4334 18.3327 15.7333 18.3327 14.3332V5.6665C18.3327 4.26637 18.3327 3.56631 18.0602 3.03153C17.8205 2.56112 17.4381 2.17867 16.9677 1.93899C16.4329 1.6665 15.7328 1.6665 14.3327 1.6665H5.66602C4.26588 1.6665 3.56582 1.6665 3.03104 1.93899C2.56063 2.17867 2.17818 2.56112 1.9385 3.03153C1.66602 3.56631 1.66602 4.26637 1.66602 5.6665V14.3332C1.66602 15.7333 1.66602 16.4334 1.9385 16.9681C2.17818 17.4386 2.56063 17.821 3.03104 18.0607C3.56582 18.3332 4.26588 18.3332 5.66602 18.3332Z",
    stroke: "#97180C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2263_16017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceActive);
export default __webpack_public_path__ + "static/media/resourceActive.f01a20c6f3ba97e25a9efb07913b6ee9.svg";
export { ForwardRef as ReactComponent };